<script lang="ts" setup>
import type { ButtonVariants } from '../../components/ui/button'
import { computed, inject } from 'vue'
import { FORM_PROCESSING_INJECTION_KEY } from '../..//components/ui/form/injectionKeys'
import { Button } from '../../components/ui/button'

const props = withDefaults(
  defineProps<{
    type?: string
    variant?: ButtonVariants['variant']
    loading?: boolean
  }>(),
  {
    type: 'submit',
  },
)

const formProcessing = inject(FORM_PROCESSING_INJECTION_KEY)

const loading = computed(() => {
  if (props.type === 'submit' && formProcessing.value) {
    return true
  }
  if (props.loading) {
    return true
  }
  return false
})
</script>

<template>
  <Button :type :variant :disabled="formProcessing" :loading>
    <slot name="icon" />
    <slot />
  </Button>
</template>
